



















































































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class TaskList extends Vue {
	tasks = [
		{
			done: false,
			text: "Foobar"
		},
		{
			done: false,
			text: "Fizzbuzz"
		}
	];
	ownTask!: string;

	get task(): string {
		return this.ownTask;
	}
	set task(val) {
		this.ownTask = val;
	}

	get completedTasks() {
		return this.tasks.filter(task => task.done).length;
	}
	get progress() {
		return (this.completedTasks / this.tasks.length) * 100;
	}
	get remainingTasks() {
		return this.tasks.length - this.completedTasks;
	}

	create() {
		this.tasks.push({
			done: false,
			text: this.ownTask
		});
		this.ownTask = "";
		this.task = "";
	}
}
